import { mapGetters, mapActions } from 'vuex';
import api from '@/services/api';
import router from '@/router';

export default {
    data() {
        return {
            password: '',
            password2: '',
            showPassword: false,
            showPassword2: false,
        };
    },

    computed: {
        ...mapGetters({
            user: 'user/user',
        }),

        resolveToken() {
            if (!router.history.current.params.hasOwnProperty('token')) {
                return null;
            }

            return router.history.current.params.token;
        }
    },

    methods: {
        submitChangedPassword() {
            if (this.fieldsAreEmpty()) {
                return;
            }
            if (this.passwordsDoNotMatch()) {
                return;
            }

            this.$Progress.start();
            const params = new URLSearchParams();

            params.append('password', this.password);
            params.append('token', this.resolveToken);

            api.post('/api/update-password', params)
                .then(() => {
                    this.$toast.success(this.$i18n.t('messages.success'));
                    this.$Progress.finish();

                    router.push('/');
                }).catch((error) => {
                    if (error.response.data.code === 'PASSWORD_RESET_FAILED_VALIDATION_ERROR' && error.response.data.body?.validation_errors?.password) {
                        this.$toast.error(error.response.data.body.validation_errors.password.join(', '))
                    } else {
                        this.$toast.error(this.$i18n.t('messages.error'));
                    }

                    this.$Progress.finish();
                });
            this.resetInputs();
        },
        /**
         * Validate user inputs
         */
        fieldsAreEmpty() {
            if (this.trimString(this.password) === '' || this.trimString(this.password2) === '') {
                this.$toast.error(this.$i18n.t('messages.emptyFields'));
                return true;
            }
            return false;
        },

        /**
         * Validate user passwords
         */
        passwordsDoNotMatch() {
            if (this.trimString(this.password) !== this.trimString(this.password2)) {
                this.$toast.error(this.$i18n.t('messages.passwordsDoNotMatch'));
                return true;
            }
            return false;
        },

        /**
         * Reset input fileds values
         */
        resetInputs() {
            this.password = '';
            this.password2 = '';
        },

        /**
         * Some browsers do not support trim() function
         * @return {*}
         * @param string
         */
        trimString(string) {
            return string.replace(/^\s+|\s+$/gm, '');
        },

        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },

        togglePassword2Visibility() {
            this.showPassword2 = !this.showPassword2;
        },
    },

    mounted() {
        this.$refs.passwordInput.focus();
    },
};
